import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import useGetVoicePolicies from '../queries/useGetVoicePolicies';

const VoicePoliciesMultiSelect = ({ darkMode, values, setFieldValue }) => {
    const { data: voicePolicies = [] } = useGetVoicePolicies();

    const selectedIds = Array.isArray(values?.voicePolicies)
        ? values.voicePolicies.map((item) => item.id)
        : [];

    const handleVoicePoliciesChange = (ids) => {
        const selected = (ids || [])
            .map((id) => voicePolicies.find((option) => option.id === id))
            .filter(Boolean);
        setFieldValue('voicePolicies', selected);
    };

    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Voice Policies
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <DropDown
                        name="voicePolicies"
                        isMulti
                        data={voicePolicies}
                        shownValue="name"
                        multiValue={selectedIds}
                        alphabetical={false}
                        placeholder="+"
                        darkMode={darkMode}
                        handleSelectChange={handleVoicePoliciesChange}
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default VoicePoliciesMultiSelect;
